import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import EntityEditFrom from './../../elements/entities/form';
import Loading from "../../elements/loading";
import EntityAdd from './../../elements/entities/widget/entity_add';

class EntityEdit extends Component {
	render (){
		const { entities, municipalities, status } = this.props;
		return(
			entities.isFetching || municipalities.isFetching ||status.isFetching ? <Loading/>:<EntityEditFrom {...this.props}/>
		);
	}

	componentWillMount() {
		this.props.fetchEntity(this.props.match.params.id);
	}
}

//export default BaseLayout(EntityEdit, {title: `Editar Entidad`, subnav: {icon: 'fa-map', name: 'Administración', actions: {url: '/entidades/crear', name: 'Agregar Entidad'}}});
export default BaseLayout(EntityEdit, {
	title: `Editar Entidad`,
	subnav: {
		icon: 'fa-map',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <EntityAdd />
			}
		]
	}
});




// WEBPACK FOOTER //
// ./src/layouts/entities/edit.jsx